var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"text":"","x-small":"","color":"primary"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t("bookingForm.BookingBackButton.editButton")))])
}
var staticRenderFns = []

export { render, staticRenderFns }